import { customTime } from "@Engage.Core";
/**
 * StartEndDatesQualifier
 * Evaluated server-side — the API reads start date (rule.Value) and end date (rule.EvaluatedObject)
 * directly from the config blob and compares against the current date.
 * The SDK sends the current UTC date as ISO string so the API has it if needed.
 * Mirrors ConneXt v2 StartEndDates which uses customTime.get() for the current date.
 */
export class StartEndDatesQualifier {
    constructor() {
        this.key = "StartEndDates";
    }
    process() {
        return customTime.get().toISOString();
    }
}
